export class Bootstrapper {
  constructor(
    private bootstrapFunction: (bootstrapper: Bootstrapper) => void
  ) {}

  /**
   * Before bootstrapping the app, we need to determine if Zone has already
   * been loaded and if not, load it before bootstrapping the application.
   */
  startup(): void {
      if ((window['Zone'] === undefined || window['Zone'] === null) && document.getElementById('zoneJS') === null) {
          // we need to load zone.js
          // This is the minified version of zone
          const zoneFile = `//cdnjs.cloudflare.com/ajax/libs/zone.js/0.9.1/zone.min.js`;
          const filesToLoad = [zoneFile];
          let sequence: Promise<any> = Promise.resolve();
          filesToLoad.forEach((file: string) => {
              sequence = sequence.then(() => {
                return this.loadScript(file, 'zoneJS');
              });
          });

          sequence.then(
              () => {
                this.bootstrapFunction(this);
              },
              (error: any) => {
                console.error('Error occurred loading necessary files', error);
              }
          );
      } else {
        if (document.getElementById('zoneJS') !== null) {
          if (document.getElementById('zoneJS').classList.contains('loaded')) {
            // zone already exists and already loaded
            this.bootstrapFunction(this);
          } else {
            document.getElementById('zoneJS').addEventListener('load', () => {
              this.bootstrapFunction(this);
            });
          }
        } else {
          this.bootstrapFunction(this);
        }
      }
  }

  /**
   * Loads a script and adds it to the head.
   * @param fileName
   * @returns a Promise that will resolve with the file name
   */
  loadScript(fileName: string, id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.id = id;
      script.src = fileName;
      script.type = 'text/javascript';
      script.onload = () => {
        resolve(fileName);
        script.classList.add('loaded');
      };
      script.onerror = () => {
        reject(fileName);
      };
      document.getElementsByTagName('head')[0].appendChild(script);
    });
  }
}



// WEBPACK FOOTER //
// ./src/bootstrapper.ts